export default __webpack_public_path__ + "static/media/javam-machado.d8e2aa41.jpg";